<?xml version="1.0" encoding="UTF-8"?>
<svg width="5" height="8" version="1.1" viewBox="0 0 5 8" xmlns="http://www.w3.org/2000/svg">
 <path id="arrow" d="m5 1-3 3 3 3-1 1-4-4 4-4z" fill-rule="evenodd"/>
</svg>
